<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :searchable="false"
            ajax-path="pingdom/checks"
        />
    </div>
</template>

<script>
import Form from '@/helpers/Form';
import Http from '@/helpers/Http';

export default {
    data() {
        return {
            refreshTable: false,
            columns: [
                {
                    title: 'Host',
                    field: 'hostname',
                    headerSort: false,
                    minWidth: 200,
                },
                {
                    title: 'Status',
                    field: 'status',
                    headerSort: false,
                    width: 100,
                    formatter({_cell}) {
                        if (_cell.value == 'up') {
                            return `<span style="color:#276749;background-color:#9AE6B4;padding: 2px 10px;border-radius:3px;font-size:12px;">${_cell.value}</span>`;
                        }

                        if (_cell.value == 'paused') {
                            return `<span style="color:#9C4221;background-color:#FBD38D;padding: 2px 10px;border-radius:3px;font-size:12px;">${_cell.value}</span>`;
                        }

                        if (_cell.value == 'down') {
                            return `<span style="color:#FFFFFF;background-color:#F56565;padding: 2px 10px;border-radius:3px;font-size:12px;">${_cell.value}</span>`;
                        }

                        if (_cell.value == 'unconfirmed_down') {
                            return `<span style="color:#975A16;background-color:#FAF089;padding: 2px 10px;border-radius:3px;font-size:12px;">${_cell.value}</span>`;
                        }

                        if (_cell.value == 'unknown') {
                            return `<span style="color:#FFFFFF;background-color:#A0AEC0;padding: 2px 10px;border-radius:3px;font-size:12px;">${_cell.value}</span>`;
                        }
                    }
                },
                {
                    title: 'Last Checked',
                    field: 'last_test_time_for_human',
                    headerSort: false,
                    minWidth: 180,
                },
                {
                    title: 'Last Error',
                    field: 'last_error_time_for_human',
                    headerSort: false,
                    minWidth: 180,
                },
                {
                    title: 'Created',
                    field: 'created_at_for_human',
                    headerSort: false,
                    minWidth: 180,
                }
            ],
            actions: [],
        }
    },
    methods: {
        
    }
}
</script>